// extracted by mini-css-extract-plugin
module.exports = {"contactId":"product-card_contactId__1Hl7U","actionButtons":"product-card_actionButtons__2_dmQ","save":"product-card_save__1p45h","close":"product-card_close__wygw-"};